<template>
  <div class="service-project app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>服务项目名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入服务项目名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>报修项目</p>
          </a-col>
          <a-col>
            <a-cascader class="app-block" v-model="table.search.project" :options="projectOptions" placeholder="请选择报修项目"></a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal" v-if="isPlatformRole">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newProject()">新增服务项目</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="repair_item_service_id" :pagination="table.page" @change="handlePageChange" v-viewer>
      <template slot="image" slot-scope="text, data">
        <dy-image :src="data.repair_item_attachment_id"></dy-image>
      </template>
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.is_show === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="scanProject(data)" v-if="!isPlatformRole">查看</a-button>
          <template v-else>
            <a-button type="link" @click="editProject(data)">编辑</a-button>
          </template>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="80%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <service-project-info :id="drawer.id" is-scan></service-project-info>
    </a-drawer>
  </div>
</template>

<script>
  import RepairItemsService from '@/io/repair_items.js';
  import ServiceProjectService from '@/io/service_project.js';
  import ServiceProjectInfo from '@/views/community/ServiceProjectInfo.vue';

  export default {
    name: 'ServiceProject',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null,
            project: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '服务项目名称',
              dataIndex: 'repair_item_service_name'
            },
            {
              title: '报修项目',
              dataIndex: 'repair_item_info.repair_item_title'
            },
            {
              title: '单价',
              dataIndex: 'repairItemPrice'
            },
            {
              title: '服务图片',
              scopedSlots: { customRender: 'image' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        projectOptions: [],
        drawer: {
          id: null,
          title: '服务项目详情',
          show: false,
        }
      }
    },
    components: {
      ServiceProjectInfo,
    },
    mounted () {
      if (this.isPlatformRole) {
        let col = this.table.columns.splice(this.table.columns.length - 1, 1)[0];
        this.table.columns = this.table.columns.concat([
          {
            title: '状态',
            scopedSlots: { customRender: 'state' },
          },
          col
        ]);
      }
    },
    activated () {
      this.initProject().then(() => {
        this.initData();
      });
    },
    methods: {
      initProject() {
        let projectOptions = []; 
        return RepairItemsService.type().then(res => {
          projectOptions = res.repair_types.map(val => {
            val.label = val.name;
            val.children = [];
            return val;
          });
          return RepairItemsService.list();
        }).then(res => {
          projectOptions.forEach((value, index) => {
            value.children = res.filter(val => val.repair_item_type === value.value).map(val => {
              val.label = val.repair_item_name;
              val.value = val.repair_items_id;
              val.parentId = value.value;
              return val;
            });
          });
          this.projectOptions = projectOptions.filter(val => val.children.length);
        }).catch(err => {});
      },
      stateChange(data) {
        let checked = data.is_show === 1;
        data.stateLoading = true;
        ServiceProjectService[checked ? 'offline' : 'online'](data.repair_item_service_id).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.is_show = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      newProject() {
        this.table.page.current = 1;
        this.$router.push({
          name: 'NewServiceProject'
        });
      },
      editProject(data) {
        this.$router.push({
          name: 'EditServiceProject',
          params: {
            id: data.repair_item_service_id
          }
        });
      },
      scanProject(data) {
        this.drawer.id = data.repair_item_service_id;
        this.drawer.show = true;
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          project: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        ServiceProjectService.listPage(
          this.table.search.name,
          this.table.search.project[0],
          this.table.search.project[1],
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.repairItemPrice = `${val.repair_item_price}元 / ${val.repair_item_unit}`;
            val.stateLoading = false;
            return val;
          });
          this.table.page.total = res.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>